import { MASTER_DATA_SERVER } from "swfrontend/AppConfigs";
import {
  CACHE_SETTINGS,
  CORS_SETTINGS,
  METHOD_GET,
  METHOD_POST,
  STANDARD_METHOD_OPTIONS,
} from "swfrontend/COMS/Utils/ApiCommunicaton";
import getCookie from "swfrontend/COMS/Utils/cookies";

export const apiRoutes = {
  login: "login",
  requestOTP: "otp/generate",
  validateOTP: "otp/validate",
};

export let AUTH_SERVER_URL = ((SERVER) =>
  `${SERVER.PROTOCOL}://${SERVER.SERVER_URL}:${SERVER.PORT}/${SERVER.API_PREFIX}`)(
  MASTER_DATA_SERVER
);

export const post_api_vendor_login_call = (app, values) =>
  fetch(AUTH_SERVER_URL + "/authentication/" + app, {
    ...STANDARD_METHOD_OPTIONS,
    ...CACHE_SETTINGS,
    ...CORS_SETTINGS,
    method: METHOD_POST,
    body: JSON.stringify(values),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie(
        `${process.env.REACT_APP_TOKEN_PREFIX}-csrftoken`
      ),
    },
  });

export const get_api_generate_otp_call = (app, values) =>
  fetch(AUTH_SERVER_URL + "/multi-auth/" + app + "?username=" + values, {
    ...STANDARD_METHOD_OPTIONS,
    ...CACHE_SETTINGS,
    ...CORS_SETTINGS,
    method: METHOD_GET,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie(
        `${process.env.REACT_APP_TOKEN_PREFIX}-csrftoken`
      ),
    },
  });

export const post_api_validate_otp_call = (app, values) =>
  fetch(AUTH_SERVER_URL + "/multi-auth/" + app, {
    ...STANDARD_METHOD_OPTIONS,
    ...CACHE_SETTINGS,
    ...CORS_SETTINGS,
    method: METHOD_POST,
    body: JSON.stringify(values),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRFToken": getCookie(
        `${process.env.REACT_APP_TOKEN_PREFIX}-csrftoken`
      ),
    },
  });
